import { render } from "./LotComponent.vue?vue&type=template&id=2d376146"
import script from "./LotComponent.vue?vue&type=script&lang=js"
export * from "./LotComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/auctions/LotComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d376146"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d376146', __exports__)) {
    console.log('reload')
    api.reload('2d376146', __exports__)
  }
  
  module.hot.accept("./LotComponent.vue?vue&type=template&id=2d376146", () => {
    console.log('re-render')
    api.rerender('2d376146', render)
  })

}


export default __exports__